import { gql } from 'apollo-angular';

export const AddTacticToFavouriteDocument = gql`
  mutation addTacticToFavourites($tacticId: Int!) {
    addTacticToFavourites(tacticId: $tacticId)
  }
`;
